module.exports = __webpack_public_path__ + "img/LoftStair.5717aafe.jpg";